export default class MetadataFormatter {
  constructor(searchResults) {
    this.searchResults = searchResults;
  }

  format() {
    let list = [];
    if (this.searchResults) {
      for (var key in this.searchResults) {
        if (!key.startsWith('@')) {
          let metadata = this.searchResults[key];
          if (metadata instanceof Array) {
            metadata.forEach(x => list.push(this.mapService(x, key)));
          } else {
            list.push(this.mapService(metadata, key));
          }
        }
      }
    }
    return list;
  }

  mapService(rService, key) {
    let data = {};
    data[key] = rService;
    const service = {
      data: data,
      title: this.getTitle(rService) || 'brak',
      westBoundLongitude: this.getBounds(rService).westBoundLongitude,
      southBoundLatitude: this.getBounds(rService).southBoundLatitude,
      eastBoundLongitude: this.getBounds(rService).eastBoundLongitude,
      northBoundLatitude: this.getBounds(rService).northBoundLatitude
    }

    return service;
  }

  getTitle(data) {
    let title = this.search(data, ['identificationInfo', 'citation', 'title', 'CharacterString']);
    return title;
  }


  getBounds(data) {
    let extentElement = this.search(data, ['identificationInfo', 'extent', 'geographicElement']);
    return {
      westBoundLongitude: this.search(extentElement, ['westBoundLongitude', 'Decimal']),
      eastBoundLongitude: this.search(extentElement, ['eastBoundLongitude', 'Decimal']),
      southBoundLatitude: this.search(extentElement, ['southBoundLatitude', 'Decimal']),
      northBoundLatitude: this.search(extentElement, ['northBoundLatitude', 'Decimal'])
    };
  }

  search(data, keyQueue) {
    let currentKey = keyQueue[0];
    let result = null;
    if (data instanceof Object && currentKey) {
      for (var key in data) {
        if (key === currentKey || key.endsWith(':' + currentKey)) {
          keyQueue.shift();
          if (keyQueue.length === 0) {
            result = data[key];
            break;
          }
        }
        result = this.search(data[key], keyQueue.map(x => x));
        if (result) {
          break;
        }
      }
    }
    return result;
  }
}